import _ from 'lodash';
import ILoan from '~Api/Loan/ILoan';
import ILoanDrawdown from '~Api/Loan/ILoanDrawdown';
import ILoanDrawdownItem from '~Api/Loan/ILoanDrawdownItem';
import ILoanPayoutFigure from '~Api/Loan/ILoanPayoutFigure';
import ILoanPayoutFigureItem from '~Api/Loan/ILoanPayoutFigureItem';
import ILoanPayoutFigureSection from '~Api/Loan/ILoanPayoutFigureSection';
import LoanPayoutFigureAccruedInterestModeEnum from '~Api/Loan/LoanPayoutFigureAccruedInterestModeEnum';
import LoanPayoutFigureMinimumTermInterestModeEnum from '~Api/Loan/LoanPayoutFigureMinimumTermInterestModeEnum';
import LoanPayoutFigurePrepaidInterestModeEnum from '~Api/Loan/LoanPayoutFigurePrepaidInterestModeEnum';
import LoanPayoutFigureSectionTypeEnum from '~Api/Loan/LoanPayoutFigureSectionTypeEnum';
import { IDictionary } from '~utilities/IDictionary';

export function getLoanPayoutFigureTotals(loan: ILoan, loanPayoutFigure: ILoanPayoutFigure): { balanceAmount: number; totalPayoutFigure: number } {
    let totalPayoutFigure: number = 0;

    if (!loanPayoutFigure.sections.some((loopSection: ILoanPayoutFigureSection) => loopSection.type === LoanPayoutFigureSectionTypeEnum.Principal)) {
        totalPayoutFigure += loanPayoutFigure.principalAmount;
    }

    if (loanPayoutFigure.accruedInterestMode === LoanPayoutFigureAccruedInterestModeEnum.Auto) {
        totalPayoutFigure += getLoanAppliedAccruedInterestTotal(loanPayoutFigure);
    }

    // Iterate over sections and their items to add their amounts to the balance amount.
    _.each(loanPayoutFigure.sections, (section: ILoanPayoutFigureSection) => {
        _.each(section.items, (item: ILoanPayoutFigureItem) => {
            totalPayoutFigure += item.amount;
        });
    });

    const appliedPrepaidInterest: number = loan.currentPaymentDate && loanPayoutFigure.prepaidInterestMode === LoanPayoutFigurePrepaidInterestModeEnum.Auto ? loanPayoutFigure.prepaidInterestAuto : loanPayoutFigure.prepaidInterest;

    const balanceAmount: number = totalPayoutFigure - loanPayoutFigure.trustAmount - appliedPrepaidInterest;

    return {
        balanceAmount,
        totalPayoutFigure,
    };
}

export function getLoanAppliedAccruedInterestTotal(loanPayoutFigure: ILoanPayoutFigure): number {
    let accruedInterestTotal: number = 0;

    if (loanPayoutFigure.accruedInterestMode === LoanPayoutFigureAccruedInterestModeEnum.Auto) {
        accruedInterestTotal += loanPayoutFigure.accruedInterest;

        if (loanPayoutFigure.minimumTermInterestMode === LoanPayoutFigureMinimumTermInterestModeEnum.Auto) {
            accruedInterestTotal += loanPayoutFigure.minimumTermInterest;
        }
    }

    return accruedInterestTotal;
}

export function getLoanDrawdownTotalToBeDisbursed(drawdown: ILoanDrawdown, drawdownItems: IDictionary<ILoanDrawdownItem>): number {
    const initialAmount: number = drawdown.approvedDrawdownAmount ? drawdown.approvedDrawdownAmount : 0;

    return _.reduce(drawdownItems, (total: number, loanDrawdownItem: ILoanDrawdownItem): number => total + loanDrawdownItem.amount, initialAmount);
}
